var _desc, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Performance-Increase--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Performance Increase Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.75 23.25h22.5",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 16.25H3c-0.19811 0.0026 -0.38737 0.0824 -0.52747 0.2225 -0.14009 0.1401 -0.21994 0.3294 -0.22253 0.5275v6.25h4.5V17c-0.00259 -0.1981 -0.08244 -0.3874 -0.22253 -0.5275 -0.1401 -0.1401 -0.32936 -0.2199 -0.52747 -0.2225Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 12.25h-3c-0.1981 0.0026 -0.3874 0.0824 -0.52747 0.2225 -0.14009 0.1401 -0.21994 0.3294 -0.22253 0.5275v10.25h4.5V13c-0.0026 -0.1981 -0.0824 -0.3874 -0.2225 -0.5275 -0.1401 -0.1401 -0.3294 -0.2199 -0.5275 -0.2225Z",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 8.25h-3c-0.1981 0.00259 -0.3874 0.08244 -0.5275 0.22253 -0.1401 0.1401 -0.2199 0.32936 -0.2225 0.52747v14.25h4.5V9c-0.0026 -0.19811 -0.0824 -0.38737 -0.2225 -0.52747 -0.1401 -0.14009 -0.3294 -0.21994 -0.5275 -0.22253Z",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.18005 9.24 16.07005 -7.3",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.0599 5.13 1.19 -3.19 -3.18 -1.19",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagement);
export default __webpack_public_path__ + "static/media/engagement.2c5ec018c74208f00ebec02421e232c5.svg";
export { ForwardRef as ReactComponent };